import { useEffect } from "react"

export default function Scripts() {
  useEffect(() => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const contentWrapper = document.querySelector('#contentWrapper');
      const mainWrapper = document.querySelector('#mainWrapper');
      const showMoreBtn = document.querySelector('#showMoreBtn');
      const showLessBtn = document.querySelector('#showLessBtn');

      const height = contentWrapper?.clientHeight;

      showMoreBtn?.addEventListener('click', () => {
        if (contentWrapper?.parentElement) {
          contentWrapper.parentElement.style.height = `${height}px`;
          showMoreBtn.classList.add('!hidden');
          showLessBtn?.classList.remove('!hidden')
        }
      });

      showLessBtn?.addEventListener('click', () => {
        if (contentWrapper?.parentElement) {
          contentWrapper.parentElement.style.height = `${150}px`;
          showMoreBtn?.classList.remove('!hidden');
          showLessBtn?.classList.add('!hidden')
        }
      });
    }
  }, [])
  return null
}